<template>
  <v-layout row wrap>
    <v-flex xs12 pa-2 sm12 md3 v-for="(item) in chart.chartData.series" :key="item.id" >
      <v-card style="height: 100%">
        <v-img
          :src="item.image"
          aspect-ratio="2.75"
          
        ></v-img>

        <v-card-title primary-title>
          <div>
            <span class="title mb-0">{{ item.title }}</span>
            <div style="height: 140px; overflow: hidden" class="body-1"> {{ item.description }} </div>
          </div>
        </v-card-title>

        <v-card-actions v-if="chart.chartData.buttonMenu && chart.chartData.buttonMenu.length">
          <v-btn flat color="orange" v-for="(item, index) in chart.chartData.buttonMenu" :key="index">{{ item.name }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>

export default {
  props: ["chart"],
  data: function() {
    return {};
  },
  components: {
  },
  methods: {

  },
  computed: {},
  mounted: function() {
    // console.log("chart.list", thchart.list);
  },
  beforeDestroy() {}
};
</script>
